export default class ScimTestError {
  constructor(errorType = '', message = '') {
    this.errorType = errorType;
    this.message = message;
  }

  format() {
    return `${this.formatErrorType()}: ${this.message}`;
  }

  formatErrorType() {
    const error = this.errorType.replace(/_/g, ' ');
    const isNotEmptyString = error && error !== '';
    const formated = isNotEmptyString ? error[0].toUpperCase() + error.substr(1) : '';
    return formated;
  }
}
